import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const CardsContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.verticalSmall};

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    flex-direction: row;
  }
`

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  overflow-y: auto;
`
